import React from "react";
export function SplashScreenComponent() {
    return (<>
            <div className={"w-full pt-60 bg-canvas flex justify-center items-center"}>
                <img alt={"logo"} src={"/img/icons/splash_screen.svg"} className={"w-1/4 h-auto"}/>
            </div>
        </>);
}
//# sourceMappingURL=splashScreenComponent.jsx.map